import { Component, Input } from '@angular/core';
import { InterviewQuestion } from '@app/models/recruiting/interview-question.model';
import { JobPostingInterviewOpinionScaleTypes } from '../../enums/job-posting-interview-opinion-scale-types.enum';

@Component({
    selector: 'app-job-posting-interview-opinion-scale-preview',
    templateUrl: './job-posting-interview-opinion-scale-preview.html',
    styleUrls: ['./job-posting-interview-opinion-scale-preview.style.scss'],
})
export class JobPostingInterviewOpinionScalePreviewComponent {
    @Input() interviewQuestion: InterviewQuestion;
    @Input() isSecondaryVariant: boolean;
    @Input('aria-labelledby') ariaLabelledBy?: string;

    opinionScaleNumbers = [1, 2, 3, 4, 5];
    opinionScaleStars = Array(5).fill(0);
    jobPostingInterviewOpinionScaleTypes = JobPostingInterviewOpinionScaleTypes;
}
